import { render, staticRenderFns } from "./TransactionalDataPane.vue?vue&type=template&id=2543226c&"
import script from "./TransactionalDataPane.vue?vue&type=script&lang=ts&"
export * from "./TransactionalDataPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2543226c')) {
      api.createRecord('2543226c', component.options)
    } else {
      api.reload('2543226c', component.options)
    }
    module.hot.accept("./TransactionalDataPane.vue?vue&type=template&id=2543226c&", function () {
      api.rerender('2543226c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/TransactionalDataPane.vue"
export default component.exports